module.exports = __webpack_public_path__ + "static/media/video.f6f10d86.mp4";